type routeTypes = "indexPage" | "createPage";

export type ApplicationType = {
  [applicationType: string]: ApplicationRoutes;
};

type ApplicationRoutes = {
  [routeKey in routeTypes]: {
    path: string;
    pathName: string;
  };
};

export const applicationTypes: ApplicationType = {
  Funeral: {
    indexPage: {
      path: "funeral-claim",
      pathName: "funeral-claim-index",
    },
    createPage: {
      path: "funeral-claim/application",
      pathName: "funeral-claim-application",
    },
  },
  Injury: {
    indexPage: {
      path: "injury-claim",
      pathName: "injury-claim-index",
    },
    createPage: {
      path: "injury-claim/application",
      pathName: "injury-claim-application",
    },
  },
  Retirement: {
    indexPage: {
      path: "retirement-claim",
      pathName: "retirement-claim-index",
    },
    createPage: {
      path: "retirement-claim/application",
      pathName: "retirement-claim-application",
    },
  },
  Sickness: {
    indexPage: {
      path: "sickness-claim",
      pathName: "sickness-claim-index",
    },
    createPage: {
      path: "sickness-claim/application",
      pathName: "sickness-claim-application",
    },
  },
  Sickness_Extension: {
    indexPage: {
      path: "sicknessext-claim",
      pathName: "sicknessext-claim-index",
    },
    createPage: {
      path: "sicknessext-claim/application",
      pathName: "sicknessext-claim-application",
    },
  },
  Maternity: {
    indexPage: {
      path: "maternity-claim",
      pathName: "maternity-claim-index",
    },
    createPage: {
      path: "maternity-claim/application",
      pathName: "maternity-claim-application",
    },
  },
  Maternity_Extension: {
    indexPage: {
      path: "maternityext-claim",
      pathName: "maternityext-claim-index",
    },
    createPage: {
      path: "maternityext-claim/application",
      pathName: "maternityext-claim-application",
    },
  },
  Unemployment: {
    indexPage: {
      path: "unemployment-claim",
      pathName: "unemployment-claim-index",
    },
    createPage: {
      path: "unemployment-claim/application",
      pathName: "unemployment-claim-application",
    },
  },
};
